module.exports = __webpack_public_path__ + "static/SampleZoo-2121e9041327143cd0ed17b94252f557.png";